export default "__VITE_ASSET__DbN3KzyL__"